import { useMoralis } from "react-moralis";
import { getEllipsisTxt } from "helpers/formatters";
import Blockie from "../Blockie";
import { Button, Card, Modal } from "antd";
import { useState, useEffect } from "react";
import Address from "../Address/Address";
import { SelectOutlined } from "@ant-design/icons";
import { getExplorer } from "helpers/networks";
import Text from "antd/lib/typography/Text";
import { connectors } from "./config";


const styles = {
  account: {
    height: "35px",
    padding: "0 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "fit-content",
    borderRadius: "20px",
    backgroundColor: "#FFAE00",
    cursor: "pointer",
  },
  text: {
    color: "#FFFFFF",
  },
  connector: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "auto",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "20px 5px",
    cursor: "pointer",
  },
  icon: {
    alignSelf: "center",
    fill: "rgb(40, 13, 95)",
    flexShrink: "0",
    marginBottom: "8px",
    height: "30px",
  },
};

function Account() {
  const { chainId, authenticate, user, isAuthenticated, logout, account, enableWeb3, isWeb3Enabled, isWeb3EnableLoading } = useMoralis();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAuthModalVisible, setIsAuthModalVisible] = useState(false);
  const [accountAddress, setAccountAddress] = useState('');

  useEffect(() => {
    setAccountAddress(user?.attributes.ethAddress);
    const connectorId = window.localStorage.getItem("connectorId");
    if(connectorId === "injected"){
      if(accountAddress?.toLowerCase() !== account?.toLowerCase()){
        setAccountAddress(account);
        return;
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, account]);

  useEffect(() => {
    
    console.log('isWeb3Enabled', isWeb3Enabled);
    console.log('isWeb3EnableLoading', isWeb3EnableLoading);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWeb3Enabled, isWeb3EnableLoading]);

  if (!isAuthenticated) {
    return (
      <>
        <div
          // style={styles.account}
          className="wallet-connect-btn"
          // onClick={() => authenticate({ signingMessage: "Hello World!" })}
          onClick={() => setIsAuthModalVisible(true)}
        >
          <p style={{ color: '#030017', fontWeight: '500'}}>Connect Wallet</p>
        </div>
        <Modal
          visible={isAuthModalVisible}
          footer={null}
          onCancel={() => setIsAuthModalVisible(false)}
          bodyStyle={{
            padding: "15px",
            fontSize: "17px",
            fontWeight: "500",
          }}
          style={{ fontSize: "16px", fontWeight: "500" }}
          width="340px"
        >
          <div style={{ padding: "10px", display: "flex", justifyContent: "center", fontWeight: "500", fontSize: "20px" }}>
            <span style={{ color: '#030017'}}> Connect Wallet </span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            {connectors.map(({ title, icon, connectorId }, key) => (
              
              <div
                style={styles.connector}
                key={key}
                onClick={async () => {
                  try {
                    window.localStorage.setItem("connectorId", connectorId);
                    await authenticate({ provider: connectorId, signingMessage:"Welcome to the Hodl4Gold (H4G) NFT Minter" } );
                    const web3 = enableWeb3({provider: connectorId})
                    console.log("web3", web3);
                    console.log("isWeb3Enabled", isWeb3Enabled);
                    setIsAuthModalVisible(false); 
                  } catch (e) {
                    console.error(e);
                  }
                }}
              >
                <img src={icon} alt={title} style={styles.icon} />
                <Text style={{ fontSize: "14px" }}>{title}</Text>
              </div>
            ))}
          </div>
        </Modal>
      </>
    );
  }

  return (
    <>
      <div style={styles.account} onClick={() => setIsModalVisible(true)}>
        <p style={{ marginRight: "5px", ...styles.text }}>{getEllipsisTxt(accountAddress, 6)}</p>
        <Blockie currentWallet accountAddress={accountAddress} scale={3} />
      </div>
      <Modal
        visible={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        bodyStyle={{
          padding: "15px",
          fontSize: "17px",
          fontWeight: "500",
        }}
        style={{ fontSize: "16px", fontWeight: "500" }}
        width="400px"
      >
        Account
        <Card
          style={{
            marginTop: "10px",
            borderRadius: "1rem",
          }}
          bodyStyle={{ padding: "15px" }}
        >
          <Address avatar="left" size={6} copyable accountAddress={accountAddress} style={{ fontSize: "20px", color: "#030017" }} />
          <div style={{ marginTop: "10px", padding: "0 10px" }}>
            <a href={`${getExplorer(chainId)}/address/${accountAddress}`} target="_blank" rel="noreferrer">
              <SelectOutlined style={{ marginRight: "5px" }} />
              View on Explorer
            </a>
          </div>
        </Card>
        <Button
          size="large"
          type="primary"
          style={{
            width: "100%",
            marginTop: "10px",
            borderRadius: "0.5rem",
            fontSize: "16px",
            fontWeight: "500",
          }}
          onClick={async () => {
           await logout(); 
            window.localStorage.removeItem("connectorId");
            window.localStorage.removeItem("user");
            setIsModalVisible(false);
          }}
        >
          Disconnect Wallet
        </Button>
      </Modal>
    </>
  );
}

export default Account;
